import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DrI18nService } from '@app/core/services/i18n/i18n.service';

@Pipe({
  name: 'drDate'
})
export class DrDateFormatPipe extends DatePipe implements PipeTransform {

  constructor(private dr18nService: DrI18nService) {
    super(dr18nService.activeLocale);
  }

  transform(value: any, args?: any): any {
    const drLocaleFormat = DrI18nService.getActiveLocaleInformation().dateDisplayFormats.piped;
    return super.transform(value, drLocaleFormat);
  }

}
